module.exports = {"331003001":"东城街道","331003002":"南城街道","331003003":"西城街道","331003004":"北城街道","331003005":"新前街道","331003006":"澄江街道","331003007":"江口街道","331003008":"高桥街道","331003101":"宁溪镇","331003102":"北洋镇","331003103":"头陀镇","331003107":"院桥镇","331003108":"沙埠镇","331003200":"屿头乡","331003201":"上郑乡","331003202":"富山乡","331003203":"茅畲乡","331003204":"上垟乡","331003205":"平田乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331003.json
// module id = 938
// module chunks = 0